import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Alunos Matriculados no Transporte',
    path: '/transporte/trarelatoriomatriculados',
    name: 'trarelatoriomatriculados',
    component: () => import('@/views/transporte/trarelatoriomatriculados/Configuracao.vue'),
    meta: {
      permissions: [eTipoPermissao.TRANSPORTEDEESTUDANTESNOVO_MENU_300801099],
    },
    goesToMenu: true,
  },
];
